import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Collapse from 'antd/lib/collapse';
import FraudCheckList from './FraudCheckList';

const CollapsePanel = Collapse.Panel;

const FraudCheckCollapse = ({ fraudCheck, t, startCheck }) => {
  
  let fraudCheckRecords = []

  fraudCheck.map(check => {
    fraudCheckRecords.push(...check.FraudCheckRecords)
  })

  //console.log(fraudCheckRecords)

  return <Collapse>
            <CollapsePanel header={t('Fraudové upozornenia')}>
              <FraudCheckList fraudCheck={fraudCheckRecords} history={fraudCheck} startCheck={startCheck} />
            </CollapsePanel>
        </Collapse>
}

FraudCheckCollapse.propTypes = {
  fraudCheck: PropTypes.array.isRequired,
  accountRole: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(FraudCheckCollapse);



// WEBPACK FOOTER //
// ./src/common/components/data-display/FraudCheckCollapse.js